export const currencyFormatter = (num) => {
  num = Number(num);
  return "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const covertSecondsToTimeClock = (time) => {
  let minutes = Math.floor(time / 60);
  let seconds = time - minutes * 60;
  let hours = Math.floor(time / 3600);
  time = time - hours * 3600;
  let str_pad_left = (string, pad, length) => {
    return (new Array(length + 1).join(pad) + string).slice(-length);
  };

  let finalTime =
    str_pad_left(minutes, "0", 2) + ":" + str_pad_left(seconds, "0", 2);
  return finalTime;
};

export const capitalizeFirstLetter = (string) => {
  if (string === undefined || string === null || string.length === 0) {
    return;
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const calculateDiscount = (cost, balance) => {
  const discount = ((cost - balance) / balance) * 100;
  return parseFloat(Math.abs(discount)).toFixed(2);
};
